import { createContext } from "react";

export const IsMapInInView = createContext<boolean>(false);
export const SetIsMapInInView = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {});
